export enum Color {
  Background = "#010727",
  Primary = "#FFFF01",
  Secondary = "#00FFFF",
  Accent = "#BC544D",
  Light = "#C4CEC2",
}
